import { Button, PrimaryLogo } from "@jem-hr/jem-ui";
import { Menu } from "lucide-react";

interface MobileTopBarProps {
  onMenuClick: () => void;
  onHomeClick: () => void;
}

export function MobileTopBar({ onMenuClick, onHomeClick }: MobileTopBarProps) {
  return (
    <div className="sm:hidden sticky top-0 z-30 flex items-center justify-between gap-sm bg-secondary-pink-50 px-sm py-xxs -mx-sm mb-md">
      <button
        type="button"
        onClick={onHomeClick}
        aria-label="Go to home"
        className="flex items-center"
      >
        <PrimaryLogo variant="bg-pink" className="h-auto w-[60px]" />
      </button>
      <Button
        variant="ghost"
        size="icon-lg"
        onClick={onMenuClick}
        aria-label="Open menu"
        className="text-secondary-pink-900 hover:bg-secondary-pink-100"
      >
        <Menu size={24} />
      </Button>
    </div>
  );
}
